import { useGebruikerContext } from "../../Context/GebruikerContext";
import CommunityTable from "./CommunityTable";
import { MatchcodesProvider, useMatchcodesContext } from "./MatchcodesContext";
import { Card, CardBody } from "reactstrap";
import Loader from "react-loaders";
import Footer from "./Footer";

const Matchcodes = ({ children }) => {
	return (
		<MatchcodesProvider>
			<div className="matchcodes">{children}</div>
		</MatchcodesProvider>
	);
};

const MatchCodesWrapper = ({ children }) => {
	const { loading } = useMatchcodesContext();

	return (
		<>
			{loading ? (
				<Card className="main-card">
					<CardBody className="d-flex flex-column">
						<Loader
							type="ball-grid-pulse"
							className={"mt-3 d-flex mx-auto justify-content-center"}
						/>
					</CardBody>
				</Card>
			) : (
				<div className="row">{children}</div>
			)}
		</>
	);
};

const MatchcodesTables = () => {
	const { currentUser } = useGebruikerContext();
	const { matchcodeData, fetchUrenoverzichtData } = useMatchcodesContext();

	return (
		<div className="row">
			{matchcodeData?.data?.map((item) => (
				<div className="col-xl-3 col-md-6 col-12" key={item.iCommunityId}>
					<CommunityTable
						data={item}
						currentUser={currentUser}
						getDataHandler={fetchUrenoverzichtData}
					/>
				</div>
			))}
		</div>
	);
};

Matchcodes.Footer = () => {
	return <Footer />;
};

Matchcodes.Tables = MatchcodesTables;
Matchcodes.Wrapper = MatchCodesWrapper;

export default Matchcodes;
